export function setLanguage(lang: 'de' | 'en'): void {
  localStorage.setItem('language', lang)
}

export function getLanguage(): 'de' | 'en' {
  return (localStorage.getItem('language') as 'de' | 'en') || 'de'
}